import { useId, type ReactNode, type SelectHTMLAttributes } from "react";

export interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: ReactNode;
  options: { value: string; label: string; disabled?: boolean }[];
}

/**
 * Выбор из короткого списка: нативный select. На телефоне это системный
 * барабан, он удобнее любого своего списка в перчатке.
 */
export function SelectField({ label, options, id, className, ...rest }: SelectFieldProps) {
  const autoId = useId();
  const selectId = id ?? autoId;
  return (
    <div className={className ? `w-field ${className}` : "w-field"}>
      <label htmlFor={selectId} className="w-field-label">
        {label}
      </label>
      <select id={selectId} className="w-input w-select" {...rest}>
        {options.map((o) => (
          <option key={o.value} value={o.value} disabled={o.disabled}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
